import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import GoalsPageContainerComponent from './GoalsPageContainer/GoalsPageContainer.container';
import { I18nContext } from 'utils/I18n/context';

const GoalsPage = ({ isSideBarOpened: propIsSideBarOpened }) => {
    const { t } = useContext(I18nContext);
    const [isSideBarOpened, setIsSideBarOpened] = useState(propIsSideBarOpened);

    const staticNames = t?.offersPage?.goalsList || { title: '' };

    return (
        <React.Fragment>
            <div className={isSideBarOpened ? "page-heading active-sidebar" : "page-heading"}>
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section
                className={isSideBarOpened ? "wrapper-content offers active-sidebar" : "wrapper-content offers"}>
                <div className="ibox">
                    <GoalsPageContainerComponent/>
                </div>
            </section>
        </React.Fragment>
    );
};

GoalsPage.propTypes = {
    isSideBarOpened: PropTypes.bool
};

GoalsPage.defaultProps = {
    isSideBarOpened: false
};

export default GoalsPage;